export const WORK_ORDER_ACTIVITY_FILTER_ALL = 'all';

export const WORK_ORDER_ACTIVITY_FILTER_CATEGORIES = [
  { key: WORK_ORDER_ACTIVITY_FILTER_ALL, label: 'All', icon: 'fa-layer-group' },
  { key: 'status', label: 'Status', icon: 'fa-clock' },
  { key: 'photos', label: 'Photos', icon: 'fa-image' },
  { key: 'notes', label: 'Notes', icon: 'fa-pen-to-square' },
  { key: 'other', label: 'Other', icon: 'fa-ellipsis-h' },
];

export const WORK_ORDER_ACTIVITY_KIND_ICONS = {
  created: { icon: 'fa-plus', tone: 'primary' },
  status_changed: { icon: 'fa-right-left', tone: 'primary' },
  checked_in: { icon: 'fa-location-dot', tone: 'primary' },
  checked_out: { icon: 'fa-location-dot', tone: 'primary' },
  completed: { icon: 'fa-circle-check', tone: 'success' },
  cancelled: { icon: 'fa-circle-xmark', tone: 'danger' },
  uncancelled: { icon: 'fa-rotate-left', tone: 'warning' },
  undo_completion: { icon: 'fa-rotate-left', tone: 'warning' },
  approved: { icon: 'fa-shield-halved', tone: 'success' },
  photo_created: { icon: 'fa-image', tone: 'info' },
  photo_destroyed: { icon: 'fa-image', tone: 'info' },
  note_created: { icon: 'fa-note-sticky', tone: 'info' },
  document_created: { icon: 'fa-file', tone: 'info' },
  assigned: { icon: 'fa-user-plus', tone: 'primary' },
  reassigned: { icon: 'fa-user-plus', tone: 'primary' },
  charge_created: { icon: 'fa-dollar-sign', tone: 'success' },
  charge_destroyed: { icon: 'fa-dollar-sign', tone: 'danger' },
  quote_created: { icon: 'fa-file-invoice-dollar', tone: 'primary' },
  quote_approved: { icon: 'fa-file-invoice-dollar', tone: 'success' },
  invoice_created: { icon: 'fa-file-invoice', tone: 'success' },
  invoice_destroyed: { icon: 'fa-file-invoice', tone: 'danger' },
  technician_payment_created: { icon: 'fa-money-bill', tone: 'success' },
};
